import { Grid, Text } from '@raskrask-dk/rr-components'
import { cloneElement, ReactElement } from 'react'

interface ItemWithHeaderProps {
    header: string
    item: ReactElement
    wrapper?: ReactElement
}

const ItemWithHeader = ({ header, item, wrapper = <></> }: ItemWithHeaderProps): ReactElement => {
    const wrapperWithItem = cloneElement(wrapper, wrapper.props, item)

    return (
        <Grid gap="4" css={{ alignContent: 'start' }}>
            <Text bold primary>
                {header}
            </Text>
            {wrapperWithItem}
        </Grid>
    )
}

export { ItemWithHeader }
